import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TimePanelTodo" */ './lazyIndex')
);

// Delayed Loaded Components
export const TaskListView = createLazyComponent(lazyModule, m => m.TaskListView);

// Delayed Loaded Actions
export const lazyLoadTaskPanelData = new LazyAction(lazyModule, m => m.loadTaskPanelData);
export const lazyInitializeQuickAdd = new LazyAction(lazyModule, m => m.initializeQuickAdd);
export const lazySwitchListAndCreateTasks = new LazyAction(
    lazyModule,
    m => m.switchListAndCreateTasks
);

// Non-lazy actions
export { clickTaskItem } from './actions/publicActions';
